export default __webpack_public_path__ + "static/ima-9133237a15daf961d76f88868b6d2a7d.png";